var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white elevation-2"},[_c('v-toolbar',{attrs:{"color":"#0065BD","flat":"","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("action")],2),_vm._v(" "),_c('div',{staticClass:"pl-2 pr-2 ml-2 mr-2 mb-2 mt-3"},[_vm._t("default",[_vm._v("\n      No "+_vm._s(_vm.title)+" results.\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-178d2976","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/Panel.vue
// module id = null
// module chunks = 